import classNames from "classnames";
import { Box } from "~/common/mui";
import { Switch } from "~/common/components/Switch/Switch";
import { useTranslation } from "react-i18next";

interface Props {
  onToggle: (newVal: boolean) => void;
  disabled?: boolean;
  selected?: boolean;
  className?: string;
  switchTestId?: string;
}

export const OnOffSwitch = ({ onToggle, disabled, className, switchTestId, selected }: Props) => {
  const { t } = useTranslation();
  return (
    <Box className={classNames(className)} sx={{ display: "flex", gap: 2, alignItems: "center" }}>
      <span>{t("notificationsSettingsPage.toggle.off")}</span>
      <Switch disabled={disabled} data-test-id={switchTestId} checked={selected} onChange={() => onToggle(!selected)} />
      <span>{t("notificationsSettingsPage.toggle.on")}</span>
    </Box>
  );
};
